module.exports = __webpack_public_path__ + "img/1a5951e228f72444fa2a8267c9f187ce.png";